function getYouTubeId (url = '') {
	const matcher = /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/
	url = url.split(matcher)
	return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_-]/i)[0] : false
}

function getVimeoId (url = '') {
	const matcher = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
	url = url.split(matcher)
	return (url[5] !== undefined) ? url[5].split(/[^0-9a-z_-]/i)[0] : false
}

export default function generateEmbedUrl (url) {
	let embedUrl = null
	const youtubeId = getYouTubeId(url)
	const vimeoId = getVimeoId(url)
	if (youtubeId) embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=0`
	if (vimeoId) embedUrl = `https://player.vimeo.com/video/${vimeoId}?autoplay=0`
	return embedUrl || false
}
